export type TaskLikeForSort = {
  task_id: number
}

/**
 * Sort tasks for display.
 *
 * NOTE: Always sorts a COPY (never mutates input).
 * Convention: newest task first (descending task_id).
 */
export function sortTasksForDisplay<T extends TaskLikeForSort>(tasks: readonly T[]): T[] {
  return [...tasks].sort((a, b) => b.task_id - a.task_id)
}
